import sessionManager from "../managers/sessionManager";
import { cookiesConstants, eventConstants } from "../constants";

const userData = sessionManager.getDataFromCookies(cookiesConstants.USER);
const userMetadata = sessionManager.getDataFromCookies(
  cookiesConstants.USER_META_DATA,
);
const deviceID = sessionManager.getDataFromCookies(cookiesConstants.DEVICE_ID);
const accessToken = sessionManager.getDataFromCookies(
  cookiesConstants.ACCESS_TOKEN,
);
const idToken = sessionManager.getDataFromCookies(cookiesConstants.ID_TOKEN);
const expiresAt = sessionManager.getDataFromCookies(
  cookiesConstants.EXPIRES_AT,
);

let initialState = {
  userDetails: userData,
  userMetadata: userMetadata,
  isLoggedIn: false,
  loginFailure: null,
  deviceID: deviceID,
  accessToken: accessToken,
  idToken: idToken,
  expiresAt: expiresAt,
  isLoading: false,
  isForgotPasswordSuccess: false,
  notificationCount: 0,
};
export default function user(state = initialState, action) {
  switch (action.type) {
    case eventConstants.SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };
    case eventConstants.HIDE_LOADER:
      return {
        ...state,
        loading: false,
      };
    case eventConstants.SIGN_IN_SUCCESS:
      sessionManager.setDataInCookies(
        action.data || state.userDetails,
        cookiesConstants.USER,
      );
      return {
        ...state,
        userDetails: action.data || state.userDetails,
        loading: false,
        isLoggedIn: true,
      };
    case eventConstants.LOGOUT_SUCCESS:
      sessionManager.setDataInCookies(false, cookiesConstants.USER);
      return {
        ...state,
        userDetails: false,
        loading: false,
        isLoggedIn: false,
      };
    default:
      return state;
  }
}
